import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute, redirect } from "@tanstack/react-router";
import { lazy } from "react";

const TodayPage = lazy(() => import("./pages/today.page").then((m) => ({ default: m.TodayPage })));
const PlanPage = lazy(() => import("./pages/plan.page").then((m) => ({ default: m.PlanPage })));
const PracticePage = lazy(() =>
	import("./pages/practice.page").then((m) => ({ default: m.PracticePage })),
);
const HistoryPage = lazy(() =>
	import("./pages/history.page").then((m) => ({ default: m.HistoryPage })),
);
const OnboardingPage = lazy(() =>
	import("./pages/onboarding.page").then((m) => ({ default: m.OnboardingPage })),
);

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach",
		component: TodayPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach/plan",
		component: PlanPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach/practice",
		beforeLoad: () => {
			throw redirect({ to: "/speech-coach" });
		},
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach/practice/$drillId",
		component: PracticePage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach/history",
		component: HistoryPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/speech-coach/onboarding",
		component: OnboardingPage,
	}),
];
